import { Link, useLocation } from 'react-router-dom';
import { useAuth, useLogout } from '../hooks/useAuth';

export function Navigation(): JSX.Element {
  const location = useLocation();
  const { user } = useAuth();
  const logoutMutation = useLogout();

  const handleLogout = () => {
    logoutMutation.mutate();
  };

  return (
    <div className='flex items-center space-x-6'>
      {/* Main Navigation */}
      <nav className='flex space-x-4'>
        <Link
          to='/dashboard'
          className={`px-4 py-2 rounded-md font-medium transition-colors ${
            location.pathname === '/dashboard'
              ? 'bg-blue-600 text-white'
              : 'text-gray-700 hover:text-gray-900 hover:bg-gray-100'
          }`}
        >
          Study
        </Link>
        <Link
          to='/admin'
          className={`px-4 py-2 rounded-md font-medium transition-colors ${
            location.pathname === '/admin'
              ? 'bg-blue-600 text-white'
              : 'text-gray-700 hover:text-gray-900 hover:bg-gray-100'
          }`}
        >
          Manage Cards
        </Link>
      </nav>

      {/* User Menu */}
      {user && (
        <div className='flex items-center space-x-4 border-l border-gray-200 pl-6'>
          <div className='text-sm text-gray-600'>
            <span className='font-medium'>{user.name || user.email}</span>
          </div>
          <button
            onClick={handleLogout}
            disabled={logoutMutation.isPending}
            className='text-sm text-gray-500 hover:text-gray-700 px-3 py-1 rounded-md hover:bg-gray-100 transition-colors disabled:opacity-50'
          >
            {logoutMutation.isPending ? 'Logging out...' : 'Logout'}
          </button>
        </div>
      )}
    </div>
  );
}
